<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <el-date-picker
                         value-format="yyyy-MM-dd HH:mm:ss"
                        size="small" style="width:300px;margin-left:30px"
                        v-model="queryModel.createTimes"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>
                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    v-loading="isLoading"
                    :data="tableData"
                    :height="bodyHeight-130"
                    style="width: 100%">
                        <el-table-column
                            prop="RecordDate"
                            label="统计日期"
                            :formatter="carTimeFilter">
                        </el-table-column>
                        <el-table-column
                            prop="Receivable"
                            label="应收">
                        </el-table-column>
                        <el-table-column
                            prop="Prepaid"
                            label="商家预付">
                        </el-table-column>
                        <el-table-column
                            prop="MerchantBalance"
                            label="商户余额">
                        </el-table-column>
                        <el-table-column
                            prop="SalesmanBalance"
                            label="刷手余额">
                        </el-table-column>
                        
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { GetReceivable } from '@/api/statistics'
 import moment from 'moment';
export default {
    data(){
        return {
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                pSize:20,
                pIndex:1,
                createTimes:[]
            }
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
    },
    mounted(){
    },
    methods: {
        query(){
            this.isLoading=true;
             var times= this.queryModel.createTimes==null?"[]":JSON.stringify(this.queryModel.createTimes)
            GetReceivable({
                createTimes:times,
                pIndex:this.queryModel.pIndex,
                pSize:this.queryModel.pSize,
            }).then(res => {
                    this.tableData=res.data.Result
                    this.total=res.data.TotalCount
                    this.isLoading = false
                })
            .catch(err => {
                console.log(err)
                this.isLoading = false
            });
        },
        carTimeFilter(row, column) {
            const daterc = row[column.property]
            if(daterc !=null){
                return moment(daterc).format("YYYY-MM-DD")
            }
        },
        reset(){
            this.queryModel={
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
            this.queryModel.createTimes = []
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        }
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>